import Vue from 'vue'

export const ShippingDocumentService = {
  list (params = []) {
    return Vue.axios.get('/shippingdocuments', { params })
      .then((response) => response.data)
  },

  create (params) {
    return Vue.axios.post('/shippingdocuments', params)
      .then((response) => response.data)
  },

  delete (id) {
    return Vue.axios.delete(`/shippingdocuments/${id}`)
  },

  item (id) {
    return Vue.axios.get(`/shippingdocuments/${id}`)
  },

  update (id, data) {
    return Vue.axios.put(`/shippingdocuments/${id}`, data)
  },

  submit (id) {
    return Vue.axios.post(`/shippingdocuments/${id}/approve`)
      .then((response) => response.data)
  },

  download (params = []) {
    return Vue.axios.get('/shippingdocuments/download',
      {
        params,
        responseType: 'blob',
        headers: { 'Accept': 'application/vnd.ms-excel' }
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'data.xlsx')
        document.body.appendChild(link)
        link.click()
      })
  }
}
